<template>
  <div class="agent-collect">
    <van-nav-bar title="邀请信息收集" />
    <div class="content">
      <van-notice-bar
        v-if="agentInfo.agentName"
        left-icon="info-o"
        :text="`代理：${agentInfo.agentName}，邀请码：${agentInfo.inviteCode}`"
      />

      <van-cell-group inset class="notice-card">
        <div class="notice-title">培训公告</div>
        <div class="notice-tip">{{ headerTip }}</div>
        <van-cell class="compact-cell" title="培训标题" :value="agentInfo.trainingTitle || trainingInfo.pxTitle || '未配置'" />
        <van-cell class="compact-cell" title="培训时间" :value="agentInfo.trainingTime || trainingInfo.pxTimeStr || '未配置'" />
        <van-cell class="compact-cell" title="培训地址" :value="agentInfo.trainingAddress || trainingInfo.pxAddres || '未配置'" />
      </van-cell-group>

      <van-cell-group inset class="summary-card stats-card">
        <van-cell title="已邀请人数" :value="inviteList.length" />
      </van-cell-group>

      <van-form @submit="onSubmit">
        <van-field
          v-model.trim="form.name"
          name="name"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field
          v-model.trim="form.phone"
          name="phone"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[
            { required: true, message: '请输入手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确手机号' }
          ]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :loading="submitting">提交</van-button>
        </div>
      </van-form>

      <div class="invite-list-wrap">
        <div class="section-title">邀请记录</div>
        <van-empty v-if="!inviteList.length" description="暂无邀请记录" />
        <van-list v-else>
          <van-cell
            v-for="item in inviteList"
            :key="item.id"
            :title="item.inviteName"
            :label="`${item.invitePhone} · ${formatTime(item.createTime)}`"
          >
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import {
  checkAgentInviteCode, getAgentInviteList, getRoomInfo, submitAgentInvite,
} from '@/api/index';

export default {
  name: 'AgentCollect',
  data() {
    return {
      inviteCode: '',
      submitting: false,
      form: {
        name: '',
        phone: '',
      },
      agentInfo: {},
      trainingInfo: {},
      inviteList: [],
      headerTip: '请先阅读该页面关联房间的培训信息，再填写姓名和手机号。',
    };
  },
  computed: {
    enteredCount() {
      return this.inviteList.filter((item) => item.isEnterRoom === 'Y').length;
    },
  },
  created() {
    const { inviteCode } = this.$route.query;
    this.inviteCode = inviteCode || '';
    if (!this.inviteCode) {
      Toast.fail('缺少邀请码参数');
      return;
    }
    this.loadInviteInfo();
    this.loadInviteList();
  },
  methods: {
    formatTime(value) {
      if (!value) return '未记录';
      return String(value).replace('T', ' ').slice(0, 19);
    },
    async loadInviteInfo() {
      try {
        const res = await checkAgentInviteCode(this.inviteCode);
        if (res.code !== 200) {
          Toast.fail(res.msg || '邀请码无效');
          return;
        }
        this.agentInfo = res.data || {};
        this.loadTrainingInfo(this.agentInfo.roomKey);
      } catch (e) {
        Toast.fail('邀请码校验失败');
      }
    },
    async loadTrainingInfo(roomKey) {
      try {
        const res = await getRoomInfo(roomKey);
        if (res.code === 200) {
          this.trainingInfo = res.data || {};
        }
      } catch (e) {
        Toast.fail('培训信息加载失败');
      }
    },
    async loadInviteList() {
      try {
        const res = await getAgentInviteList(this.inviteCode);
        if (res.code === 200) {
          this.inviteList = res.data || [];
        }
      } catch (e) {
        Toast.fail('邀请记录加载失败');
      }
    },
    async onSubmit() {
      if (!this.inviteCode) {
        Toast.fail('邀请码缺失');
        return;
      }
      this.submitting = true;
      try {
        const res = await submitAgentInvite(this.inviteCode, this.form.name, this.form.phone);
        if (res.code === 200) {
          Toast.success('提交成功');
          this.form.name = '';
          this.form.phone = '';
          this.loadInviteList();
          return;
        }
        Toast.fail(res.msg || '提交失败');
      } catch (e) {
        Toast.fail('网络异常，提交失败');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.agent-collect {
  min-height: 100vh;
  background: #f7f8fa;
}

.content {
  max-width: 720px;
  margin: 0 auto;
  padding-top: 12px;
}

.notice-card {
  margin: 12px 12px 0;
  overflow: hidden;
}

.notice-title {
  padding: 10px 16px 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1989fa;
}

.notice-tip {
  padding: 0 16px 8px;
  color: #646566;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notice-card :deep(.van-cell) {
  padding-top: 8px;
  padding-bottom: 8px;
}

.notice-card :deep(.van-cell__title),
.notice-card :deep(.van-cell__value) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notice-card :deep(.van-cell__value) {
  flex: 1.8;
}

.invite-list-wrap {
  margin: 16px 12px 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #323233;
}
</style>
